import { render, staticRenderFns } from "./IneligibleOrDependentEmail.vue?vue&type=template&id=2f4d9cab&scoped=true"
import script from "./IneligibleOrDependentEmail.vue?vue&type=script&lang=js"
export * from "./IneligibleOrDependentEmail.vue?vue&type=script&lang=js"
import style0 from "./IneligibleOrDependentEmail.vue?vue&type=style&index=0&id=2f4d9cab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d9cab",
  null
  
)

export default component.exports